module.exports = __webpack_public_path__ + "static/media/bicolorana_bicolor_004_APA.8f7d78fe.mp3";